import UserScenario from '@/api/account/user/scenario';
import UserQuery from '@/api/account/user/query';

export const auth = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    isLoggedIn: false,
    username: '',
    email: '',
    userId: '',
    isSuperuser: false,
    profile: {},
    company: {},
    supportEmail: '',
    isDispSupportTel: true,
    isDispPoweredLabel: false,
    isUserGroupUsable: false,
    isProfessionalPlan: false,
    isVersionMngUsable: false,
    isProfessionalPlanTrial: false
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    getUserName: state => state.username,
    getEmail: state => state.email,
    getUserId: state => state.userId,
    isSuperuser: state => state.isSuperuser,
    getProfile: state => state.profile,
    getCompany: state => state.company,
    isProfessionalPlan: state => state.isProfessionalPlan,
    isProfessionalPlanTrial: state => state.isProfessionalPlanTrial,
    isUserGroupUsable: state => state.isUserGroupUsable,
    isVersionMngUsable: state => state.isVersionMngUsable,
    getSupportEmail: state => state.supportEmail,
    isDispSupportTel: state => state.isDispSupportTel
  },
  mutations: {
    loggedIn(state, refresh) {
      state.isLoggedIn = true;
      localStorage.setItem('refresh', refresh);
    },
    loggedOut(state) {
      state.isLoggedIn = false;
      state.profile = {};
      state.isSuperuser = false;
      localStorage.removeItem('refresh');
    },
    setUserInfo(state, userInfo) {
      state.userId = userInfo.id;
      state.username = userInfo.username;
      state.email = userInfo.email;
      state.profile = userInfo.profile;
      state.company = userInfo.profile.company;
      state.isSuperuser = userInfo.isSuperuser;
      state.supportEmail = userInfo.profile.supportEmail;
      state.isDispSupportTel = userInfo.profile.isDispSupportTel;
      state.supportEmail = userInfo.profile.supportEmail;
      state.isUserGroupUsable = userInfo.profile.company.companyContracts.userGroup;
      state.isProfessionalPlan = userInfo.profile.company.companyContracts.professionalPlan;
      state.isProfessionalPlanTrial = userInfo.profile.company.companyContracts.professionalPlanTrial;
      state.isVersionMngUsable = userInfo.profile.company.companyContracts.versionManagement;
      if (state.profile.company) {
        state.isDispPoweredLabel = state.profile.company.inflowRouteType === 5;
        localStorage.setItem('isCloudsignReview', state.isDispPoweredLabel);
      } else {
        state.isDispPoweredLabel = false;
        localStorage.setItem('isCloudsignReview', false);
      }
    },
    closeUserSettingsWindow() {
      setTimeout(() => {
        const userSettingsWindow = window.open('', 'UserSettings');
        if (userSettingsWindow) userSettingsWindow.close();
      }, 1);
    }
  },
  actions: {
    login({ dispatch, commit }, [email, password]) {
      return UserScenario.login(email, password).then(res => {
        commit('loggedIn', res.data.data.refreshToken);
        commit('setUserInfo', res.data.data.user);
        commit('checkPoint/setCheckAvailablePoint', res.data.data.user.profile.company.checkAvailablePoint, { root: true });
        commit('checkPoint/setLecheckDownloadAvailablePoint', res.data.data.user.profile.company.lecheckDownloadAvailablePoint, {
          root: true
        });
        dispatch('userTemplate/clear', null, { root: true });
        dispatch('userSettings/setUserDialogSettings', null, { root: true });
        return res;
      });
    },
    logout({ dispatch, commit }) {
      dispatch('category/clearCategoryTree', null, { root: true });
      dispatch('contractPartyMaster/clearContractPartyMasters', null, { root: true });
      dispatch('user/clearUsers', null, { root: true });
      dispatch('searchJoubun/destroy', null, { root: true });
      dispatch('review/destroy', null, { root: true });
      dispatch('diff/destroy', null, { root: true });
      dispatch('userTemplate/clear', null, { root: true });
      dispatch('userTemplate/destroy', null, { root: true });
      dispatch('checkPoint/clear', null, { root: true });
      commit('closeUserSettingsWindow');
      commit('loggedOut');
    },
    tryLoggedIn({ commit }) {
      const refresh = localStorage.getItem('refresh');
      return UserScenario.refresh(refresh)
        .then(() => {
          commit('loggedIn', refresh);
        })
        .catch(error => {
          localStorage.removeItem('refresh');
          return Promise.reject(error);
        });
    },
    updateUserInfo({ commit, dispatch }) {
      UserQuery.getUserDetail().then(res => {
        const data = res.data.data;
        commit('setUserInfo', data);
        commit('checkPoint/setCheckAvailablePoint', data.profile.company.checkAvailablePoint, { root: true });
        commit('checkPoint/setLecheckDownloadAvailablePoint', data.profile.company.lecheckDownloadAvailablePoint, { root: true });
      });
      dispatch('userSettings/setUserDialogSettings', null, { root: true });
    },
    inspecteCheckPoint({ dispatch, state }) {
      dispatch('auth/updateUserInfo');
      if (state.company.companyContracts.professionalPlan || state.company.companyContracts.professionalPlanTrial) {
        return;
      }

      const checkPoint = state.company.checkAvailablePoint;
      const supportEmail = state.supportEmail;
      let telMessage = 'お電話：050-1790-4607（平日10：00-17：00）';
      if (!state.isDispSupportTel) {
        telMessage = '';
      }
      if (0 < checkPoint && checkPoint <= 3) {
        dispatch(
          'message/setWarningMessage',
          {
            title: 'チェック利用ポイントのご案内',
            message: `チェック利用ポイントが残り少なくなっております。\n
残り：${checkPoint}ポイント
ポイントを追加する場合は、当社サポートにご連絡ください。
${telMessage}
メール：${supportEmail}
何卒よろしくお願いいたします。`
          },
          { root: true }
        );
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js